export default __webpack_public_path__ + "static/media/logo1.0ef0eaa6.png";